import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { Typography } from "../../shared/uikit/Typography";
import { CtaButton } from "./common/CtaButton";

export const ConversationClosedCta = () => {
  const history = useHistory();

  return (
    <div className="bg-primary flex flex-col items-center justify-center gap-4 py-8">
      <Typography.LabelMd weight="bold" color="inverse">
        {t("help_widget.conversation_page.conversation_closed_cta_title")}
      </Typography.LabelMd>

      <CtaButton
        label={t(
          "help_widget.conversation_page.conversation_closed_cta_button_label",
        )}
        onClick={() => {
          history.push("/");
        }}
      />
    </div>
  );
};
